// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__-dN0b","item":"PaymentsMobile_item__350k1","label":"PaymentsMobile_label__1ybHC","amount":"PaymentsMobile_amount__2tzM1"};